import Vue from "vue"

import { Modal } from "buefy"

Vue.use(Modal)
